import React from "react";
import { useTranslation } from "react-i18next";

const TicketsSAVPreview = () => {
  const { t } = useTranslation("common");
  const ticketsSAVPreviewTitles = [
    { id: 1, label: "#", className: "w10" },
    { id: 1, label: t("Reseller"), className: "w20" },
    { id: 2, label: t("Ticket Date"), className: "w20" },
    { id: 3, label: t("Delivery Date"), className: "w20" },
    // { id: 4, label: "Ref Client", className: "w15" },
    { id: 5, label: t("Status"), className: "w15" },
    { id: 6, label: t("Issue"), className: "w15" },
    { id: 7, label: t("Technician"), className: "w15" },
  ];

  return (
    <div className="bg-dimGrey orderListTable py-3 px-4 alignH ">
      {ticketsSAVPreviewTitles?.map(({ id, label, className }) => (
        <span
          className={` f14 text-brightGrey sBold pe-3 ${className}`}
          style={{ textAlign: "left" }}
          key={id}
        >
          {label}
        </span>
      ))}
      <span className="w3"></span>
    </div>
  );
};

export default TicketsSAVPreview;
